export default __webpack_public_path__ + "static/reassuringEnchanted-3d4ff7629c166b57f0dc5f33775e391b.svg";